/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Connected_Sources_LabelInputs */

const es_tyc_definitions_connected_sources_label = /** @type {(inputs: Tyc_Definitions_Connected_Sources_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes Conectadas`)
};

const en_tyc_definitions_connected_sources_label = /** @type {(inputs: Tyc_Definitions_Connected_Sources_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected Sources`)
};

/**
* | output |
* | --- |
* | "Connected Sources" |
*
* @param {Tyc_Definitions_Connected_Sources_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_connected_sources_label = /** @type {((inputs?: Tyc_Definitions_Connected_Sources_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Connected_Sources_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_connected_sources_label(inputs)
	return en_tyc_definitions_connected_sources_label(inputs)
});
export { tyc_definitions_connected_sources_label as "tyc.definitions.connected_sources_label" }